import React from 'react';

import UpDownArrowIcon from '../../icons/UpDownArrowIcon';

function AssessmentsSort({ toggleSort, sortKey, sortOrder }) {
  return (
    <div className="assessments-list__head">
      <div className="assessments-list__col-1" />
      <div className="assessments-list__col-2">
        <button onClick={() => toggleSort('section')} type="button">
          Module
          {sortKey === 'section' && <UpDownArrowIcon direction={sortOrder} /> }
        </button>
      </div>
      <div className="assessments-list__col-3">
        <button onClick={() => toggleSort('dateCreated')} type="button">
          Created
          {sortKey === 'dateCreated' && <UpDownArrowIcon direction={sortOrder} /> }
        </button>
      </div>
      <div className="assessments-list__col-4">
        <button onClick={() => toggleSort('dateUpdated')} type="button">
          Submitted
          {sortKey === 'dateUpdated' && <UpDownArrowIcon direction={sortOrder} /> }
        </button>
      </div>
      <div className="assessments-list__col-5">
        <button onClick={() => toggleSort('assessor')} type="button">
          User
          {sortKey === 'assessor' && <UpDownArrowIcon direction={sortOrder} /> }
        </button>
      </div>
    </div>
  );
}

export default AssessmentsSort;


// WEBPACK FOOTER //
// ./src/components/features/dashboard/AssessmentsSort.js